import { render, staticRenderFns } from "./travelInsurance.vue?vue&type=template&id=051582d7&"
import script from "./travelInsurance.vue?vue&type=script&lang=js&"
export * from "./travelInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports